import {SendStoreLocatorForm} from "@/interfaces";
import axios from "axios";

class FormService {
    constructor() {
    }

    async send(body: SendStoreLocatorForm): Promise<any> {
        try {
            return await axios.post('/frontend/send-dealer', body);
        } catch (error: any) {
            return {...error, status: error?.statusCode ?? 500, message: error?.message ?? 'ERROR'};
        }

    }
}

export default new FormService();